import api from '../../helpers/axios'
export const state = {
    content: null,
    contents: [],
    courseId: null,
    props: {
        courseId: String,
        examId: String,
        contentId: String,
    },
};


export const getters = {
    content: (state) => state.content,
    contents: (state) => state.contents,
};

export const mutations = {
    setContent(state, newValue) {
        state.content = newValue;
    },
    setContents(state, newValue) {
        state.contents = newValue;
    },
    setCourseId(state, newValue) {
        state.courseId = newValue;
    },
    setExamId(state, newValue) {
        state.examId = newValue;
    },
    setContentId(state, newValue) {
        state.contentId = newValue;
    },


};
export const actions = {

    /* eslint-disable */
    createContent(_, {data, courseId}) {
        return new Promise((resolve,reject) => {

            api.post(`/courses/${courseId}/contents` , data).then((res) => {
                if(res){
                    resolve(res.data.data)
                }
            }).catch((err) => {
                reject(err)
            })
        });
    },
    updateContent(_, {courseId, contentId, data}) {

        return new Promise((resolve, reject) => {
            api.put(`/courses/${courseId}/contents/`+ contentId, data).then((res) => {
                resolve(res.data.data);
            }).catch((err) => {
                reject(err);
            });
        });
    },




    deleteContent(_,{courseId, contentId}) {
        return new Promise((resolve) => {
            api.delete(`/courses/${courseId}/contents/${contentId}`).then((res) => {
                resolve(res.data.data);
            });
        });
    },




    fetchContent({ commit }, {id}) {
        return new Promise((resolve,reject) => {
            api.get("/contents/"+id).then((res) => {
                commit("setContent", res.data.data);
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },

    fetchContents({ commit }, { name, type,courseId, description, isActive, page, limit, listType }) {
        let query = "?";

        if (listType) {
            query += `listType=${listType}&`;
        } else {
            query += `page=${page}&`;
            query += `limit=${limit}&`;
        }

        if (name) {
            query += `name=${name}&`;
        }

        if (type) {
            query += `type=${type}&`;
        }

        if (description) {
            query += `description=${description}&`;
        }

        if (isActive !== undefined) {
            query += `isActive=${isActive}&`;
        }

        return new Promise((resolve) => {
            api.get(`/courses/${courseId}/contents` + query).then((res) => {
                commit("setContents", res.data.data);
                resolve(res.data.data);
            });
        });
    },


    fetchDetailContents({ commit }, { name, type,courseId, description, isActive, page, limit, listType }) {
        let query = "?";

        if (listType) {
            query += `listType=${listType}&`;
        } else {
            query += `page=${page}&`;
            query += `limit=${limit}&`;
        }

        if (name) {
            query += `name=${name}&`;
        }

        if (type) {
            query += `type=${type}&`;
        }

        if (description) {
            query += `description=${description}&`;
        }

        if (isActive !== undefined) {
            query += `isActive=${isActive}&`;
        }

        return new Promise((resolve) => {
            api.get(`/courses/${courseId}/contents` + query).then((res) => {
                commit("setContents", res.data.data);
                resolve(res.data.data);
            });
        });
    }

};
